import { Fragment } from "react";

import FormOne from "./FormOne";
import FormThree from "./FormThree";
import EditButtons from "../../../components/EditButtons";
import SubNavbar from "../../../components/SubNavbar";
import { ButtonFooter } from "../../../components";

export default function FormDisplay({
  state,
  dispatch,
  fields,
  editState,
  setEditState,
  formikProps,
  categories,
  setFields,
}) {
  return (
    <Fragment>
      <SubNavbar
        pageName={"Audience Details"}
        buttons={[
          editState ? (
            <Fragment></Fragment>
          ) : (
            <EditButtons editState={editState} setEditState={setEditState} />
          ),
        ]}
      />
      <FormOne
        setFields={setFields}
        categories={categories}
        state={state}
        dispatch={dispatch}
        fields={fields}
        formikProps={formikProps}
        editState={editState}
        setEditState={setEditState}
      />

      <FormThree
        state={state}
        dispatch={dispatch}
        fields={fields}
        formikProps={formikProps}
        editState={editState}
        setEditState={setEditState}
      />

      <ButtonFooter
        ID={formikProps.values.ID}
        editState={editState}
        setEditState={setEditState}
        formikProps={{
          ...formikProps,
          dirty: true,
        }}
      />
    </Fragment>
  );
}
